export default {"src":"/_next/static/media/ico_user.2e182ff7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};